import React from 'react';
import { styled, palette } from '@landr/maestro';
import { FormFields } from 'types';
import { NewPackFormFields } from 'pages/NewPack/NewPack.types';
import { FormFieldComponentProps } from './Form';

const StyledSelect = styled.select`
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: block;
    width: 100%;
    font-size: 1rem;
    background: none;
    color: white;
    border: solid 1px;
    border-radius: '20px';
    padding: 11px;
    border-color: rgba(0, 0, 0, 0);
    background-color: #2c3c4d;
    &:focus,
    &:hover {
        outline: none;
        border-color: ${palette('neutral.400')} !important;
    }
    &.isInvalid {
        border-color: ${palette('danger.500')} !important;
    }
    &:disabled {
        opacity: 0.2;
    }

    option {
        color: ${palette('neutral.1000')};
    }

    &:before {
        position: absolute;
        top: 50%;
        right: 20px;
        content: ' ';
        width: 0;
        height: 0;
        margin-top: -5px;
        border-style: solid;
        border-width: 8px 5px 0 5px;
        border-color: #fff;
        pointer-events: none;
    }
`;

type SelectProps = {
    fieldProps: FormFieldComponentProps<FormFields | NewPackFormFields>;
    options?: { key: string; value: string }[];
};

const Select = ({ fieldProps, options }: SelectProps) => {
    return (
        <StyledSelect {...fieldProps} disabled={!options}>
            <option value="">Choose...</option>
            {options &&
                options.map(({ key, value }) => (
                    <option value={key} key={key}>
                        {value}
                    </option>
                ))}
        </StyledSelect>
    );
};

export default Select;
